import { Button } from '@musinsa/mds';

import type { ComponentProps, FC } from 'react';

type MdsButtonProps = ComponentProps<typeof Button>;

const MdsButton: FC<MdsButtonProps> = ({ children, ...props }) => (
  <Button {...props}>{children}</Button>
);

export { MdsButton, type MdsButtonProps };
